import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { ChangeDetectorRef, Component, Input, LOCALE_ID, SimpleChanges } from '@angular/core';
import { MbscModule } from '@mobiscroll/angular';
import { categoryData, platformIcons, statusData } from '../../../interfaces/selectData';
import localeDe from '@angular/common/locales/de';
import { StackingContext } from 'html2canvas/dist/types/render/stacking-context';
import { ColorService } from '../../../services/shared/color/color.service';
import { IconService } from '../../../services/shared/icons/icon.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SvgIconService } from '../../../services/shared/icons/svg-icon.service';
interface OnlineLinkItem {
  platform: string;
  link: string;
  description?: string;
}

@Component({
  standalone: true,
  selector: 'app-event-view-export',
  imports: [CommonModule, MbscModule],
  templateUrl: './event-view-export.component.html',
  styleUrl: './event-view-export.component.scss',
  providers: [DatePipe, { provide: LOCALE_ID, useValue: 'de' },]
})
export class EventViewExportComponent {
 @Input() event: any;
  @Input() inst: any;
  @Input() myResources: any;
  @Input() dragging: any;
  @Input() filteredCustomers: any;
  @Input() viewMode: any;
  coIds: number[] = [];
  coData: any;
  fremdData: any;
  missing:boolean = false;
  overload: boolean = false;
  categoryData = categoryData;
  statusData = statusData;
  formattedStart: any;
  formattedEnd: any;
  eventMarker: boolean = false
  platformIcons = platformIcons
  
  constructor(public datePipe: DatePipe, public colorService: ColorService, public iconService: IconService, public http: HttpClient, public svgIconService: SvgIconService){
    registerLocaleData(localeDe);
  }
  

  ngOnInit(){   
    if(this.event.resource === "Allgemein") {
      this.event.html = 'Zeit Makierung'
      this.event.title = 'Zeit Makierung'
      this.event.style.color = "#ffeeba"
      this.eventMarker = true
    } 
    if(this.event.original.isTempEvent && !this.dragging){
      this.coIds = this.checkForCoInterpretersTemp();
      this.coData = this.getCoDataTemp();
      this.fremdData = this.getFremdData();
      this.checkForMissingInterpretersTemp();
    }else if(!this.dragging && this.event.original.resource && this.event.original.resource.length > 0){
      this.coIds = this.checkForCoInterpreters();
      this.coData = this.getCoData();
      this.fremdData = this.getFremdData();
      this.checkForMissingInterpreters();
    }
    
    this.getFormattedTime()
    //console.log('coData: ', this.coData)
  }


  ngOnChanges(changes: SimpleChanges){
    if(this.event.original.isTempEvent && !this.dragging){
      this.coIds = this.checkForCoInterpretersTemp();
      this.coData = this.getCoDataTemp();
      this.fremdData = this.getFremdData();
      this.checkForMissingInterpretersTemp();
    }else if(!this.dragging && this.event.original.resource && this.event.original.resource.length > 0){
      this.coIds = this.checkForCoInterpreters();
      this.coData = this.getCoData();
      this.fremdData = this.getFremdData();
      this.checkForMissingInterpreters();
    }
  }


  getFormattedTime(){
    const start = new Date(this.event.original.start);
    const end = new Date(this.event.original.end);
    this.formattedStart = this.datePipe.transform(start, 'd. MMMM y HH:mm');
    this.formattedEnd = this.datePipe.transform(end, 'HH:mm');
  }


  // checkForCoInterpreters() {
  //   if(Array.isArray(this.event.resource) && this.event.resource.length > 0 && this.event.resource[0] !== null){
      
  //     const interpreterId = this.event.currentResource.id;
  //     const coInterpreterIds = this.event.resource.filter((coId: any) => {
  //       return coId !== interpreterId;
  //     });
      
  //     return coInterpreterIds;
  //   }
  // }
  // TESTEN

 checkForCoInterpreters(): number[] {
  if (
    !Array.isArray(this.event?.resource) ||
    this.event.resource.length === 0 ||
    this.event.resource.some((r: any) => r == null)
  ) {
    return [];
  }

  const interpreterId = this.event.currentResource?.id;

  if (!interpreterId) {
    return [...this.event.resource];
  }

  return this.event.resource.filter(
    (id: number) => id !== interpreterId
  );
}



  
  checkForCoInterpretersTemp() {
    if(Array.isArray(this.event.original.eventResources)){
      const interpreterId = this.event.currentResource.id;
      const coInterpreterIds = this.event.original.eventResources.filter((coId: any) => {
        return coId !== interpreterId;
      });
      
      return coInterpreterIds;
    }
  }


  getCoData() {
    if(Array.isArray(this.event.resource) && this.event.resource.length > 0 && this.event.resource[0] !== null){
      const coData = this.myResources.filter((co: any) => {
        return this.coIds.includes(co.id);
      });
  
      return coData;
    }
  }


  getCoDataTemp() {
    if(Array.isArray(this.event.original.eventResources)){
      const coData = this.myResources.filter((co: any) => {
        return this.coIds.includes(co.id);
      });
  
      return coData;
    }
  }


  getFremdData() {
    if(Array.isArray(this.event.original.informations) && this.event.original.informations.some((info: { title: string; }) => info.title === 'Fremd Dolmetscher')){
      const index = this.event.original.informations.findIndex(
        (info: { title: string }) => info.title === 'Fremd Dolmetscher'
      );
      const fremdData = this.event.original.informations[index].options;
      return fremdData;
    }
  }

  getInformationTitle(info: any): string {
  if (!info) {
    return '';
  }

  // Spezialfall Sprachlevel
  if (info.title === 'Sprachlevel' || info.icon_name === 'globe') {
    return info.value
      ? `Sprachlevel: ${info.value}`
      : 'Sprachlevel';
  }

  // Fallback: normales Icon
  return this.iconService.getIconTitle(info.icon_name);
}

  getSprachlevel(info: any): string {
    if (!info) return '';
    return info.value ?? '';
  }

    
  checkForMissingInterpreters(){
    //Intern Resources herausfiltern
    const filteredResources = this.event.resource.filter((resourceId: any) => {
      const resource = this.myResources.find((r: { id: any; }) => r.id === resourceId);
      return resource?.team !== 'Intern';
    })

    const plannedInt = filteredResources.length + (this.fremdData?.length || 0);
    const neededInt = this.event.original.dolmetscher ?? 1;
    
    if(plannedInt < neededInt){
      this.missing = true;
    }else{
      this.missing = false;
    }

    if(plannedInt > neededInt){
      this.overload = true;
    }else{
      this.overload = false;
    }
  }


  checkForMissingInterpretersTemp(){
    //Intern Resources herausfiltern
    const filteredResources = this.event.original.eventResources.filter((resourceId: any) => {
      const resource = this.myResources.find((r: { id: any; }) => r.id === resourceId);
      return resource?.team !== 'Intern';
    })

    const plannedInt = filteredResources.length + (this.fremdData?.length || 0);
    const neededInt = this.event.original.dolmetscher ?? 0;

    if(plannedInt < neededInt){
      this.missing = true;
    }else{
      this.missing = false;
    }

    if(plannedInt > neededInt){
      this.overload = true;
    }else{
      this.overload = false;
    }
  }

  
  getCustomerNames(event: any): string {
    let customers = event?.original?.customer ?? event?.customer;
 
    if (!Array.isArray(customers) || customers.length === 0) {
      return '- ?'; // kein Customer vorhanden
    }
  
    const names = customers.map(customer =>(
      customer.firstname + ' ' + customer.lastname
    )).join(' ,')

    if(names.includes('null')){
      return '- ?'
    }else{
      return names ? `- ${names}` : '- ?';
    }
  }

  getStundenRelevanz(event: any){
    if (!event.resourceMeta || !Array.isArray(event.resourceMeta)) {
      return false;
    }
    if(event){
      if(event.isTempEvent){
        const found = event.resourceMeta.find((item: { id: any; }) => item.id === event.resource);
        return found ? found.stunden : undefined;
      }else{
            const found = event.resourceMeta.find((item: { id: any; }) => item.id === event.resource[0]);
        return found ? found.stunden : undefined;
      }
    }
  }
}
